var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4392 7.49167C11.9308 6.735 8.01417 10.825 8.33333 16.25M5 7.5C5 7.94203 5.17559 8.36595 5.48816 8.67851C5.80072 8.99107 6.22464 9.16667 6.66667 9.16667C7.10869 9.16667 7.53262 8.99107 7.84518 8.67851C8.15774 8.36595 8.33333 7.94203 8.33333 7.5C8.33333 7.05797 8.15774 6.63405 7.84518 6.32149C7.53262 6.00893 7.10869 5.83334 6.66667 5.83334C6.22464 5.83334 5.80072 6.00893 5.48816 6.32149C5.17559 6.63405 5 7.05797 5 7.5Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.8883C4.81667 10.5675 7.37583 11.9658 8.5 13.75",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96484 7.75C1.96484 6.35 1.96484 5.65 2.23734 5.115C2.47702 4.64462 2.85946 4.26218 3.32984 4.0225C3.86484 3.75 4.56484 3.75 5.96484 3.75H14.0365C15.4365 3.75 16.1365 3.75 16.6715 4.0225C17.1416 4.26232 17.5237 4.64474 17.7632 5.115C18.0365 5.65 18.0365 6.35 18.0365 7.75V12.25C18.0365 13.65 18.0365 14.35 17.764 14.885C17.5243 15.3554 17.1419 15.7378 16.6715 15.9775C16.1365 16.25 15.4365 16.25 14.0365 16.25H5.96484C4.56484 16.25 3.86484 16.25 3.32984 15.9775C2.85977 15.7377 2.47764 15.3553 2.23818 14.885C1.96484 14.35 1.96484 13.65 1.96484 12.25V7.75Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection);
export default __webpack_public_path__ + "static/media/section.5665ee3ba45acc4cb84b8e71d2aa0f4a.svg";
export { ForwardRef as ReactComponent };